import { TransitionGroup, CSSTransition } from 'react-transition-group'
import styled from '@emotion/styled'
import {
  selectNav,
  toggleNav,
  useAppDispatch,
  useAppSelector,
} from '@open-tender/cloud'

const NavOverlayContainer = styled.div`
  position: fixed;
  z-index: 16;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${(props) => props.theme.overlay.dark};
`

const NavOverlay = () => {
  const dispatch = useAppDispatch()
  const { isOpen } = useAppSelector(selectNav)
  return (
    <TransitionGroup component={null}>
      {isOpen ? (
        <CSSTransition key="nav-overlay" classNames="md" timeout={250}>
          <NavOverlayContainer onClick={() => dispatch(toggleNav())} />
        </CSSTransition>
      ) : null}
    </TransitionGroup>
  )
}

export default NavOverlay
